import { render, staticRenderFns } from "./OrderListScheduledPage.vue?vue&type=template&id=73aa888c&scoped=true&"
import script from "./OrderListScheduledPage.vue?vue&type=script&lang=js&"
export * from "./OrderListScheduledPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa888c",
  null
  
)

export default component.exports